import React from 'react';
import './FeaturedProjectsStyles.css';

const FeaturedProjects = ({ projects }) => {
  return (
    <div className="stack-projects">
      {projects.map((project, index) => (
        <div className="stack-card-wrap" style={{ '--i': index }} key={project.id}>
          <div className="stack-card">
            <div className="stack-card-image">
              <img src={project.image} alt={project.name} loading="lazy" />
            </div>
            <div className="stack-card-body">
              <div className="stack-card-header">
                <h3>{project.name}</h3>
                {project.link ? (
                  <a
                    className="stack-card-link"
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Ver ${project.name}`}
                  >
                    ↗
                  </a>
                ) : (
                  <span className="stack-card-badge">{project.linkLabel}</span>
                )}
              </div>
              <p className="stack-card-desc">{project.description}</p>
              <div className="stack-card-tech">
                {project.tech.join(' · ')}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeaturedProjects;
